import axios from "axios";
import { msalInstance, apiScope } from "../config/AuthProvider";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_AWS_API,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      try {
        const response = await msalInstance.acquireTokenSilent({
          ...apiScope,
          account: accounts[0],
        });
        // eslint-disable-next-line no-param-reassign
        config.headers.Authorization = `Bearer ${response.accessToken}`;
        return Promise.resolve(config);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error acquiring token:", error);
        return Promise.resolve(config);
      }
    }
    return Promise.resolve(config);
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default axiosInstance;
